import React, { createContext, useContext, ReactNode } from 'react';

// Define la estructura de la información que comunicaremos (los valores del padding)
interface LayoutContextType {
  mainContainerPaddingX: { xs: number; sm: number } | null;
}

// Creamos el Contexto. Su valor por defecto es `null`, indicando que no hay padding.
export const LayoutContext = createContext<LayoutContextType>({
  mainContainerPaddingX: null,
});

// Creamos un 'hook' para que los componentes puedan acceder fácilmente a esta información.
export const useLayout = () => useContext(LayoutContext);

// Creamos el componente 'Proveedor' que usaremos en MainLayout para enviar la información.
interface LayoutProviderProps {
  children: ReactNode;
  paddingX: { xs: number; sm: number } | null;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children, paddingX }) => {
  return (
    <LayoutContext.Provider value={{ mainContainerPaddingX: paddingX }}>
      {children}
    </LayoutContext.Provider>
  );
};